<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Kategori SOS</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="kategoriList"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          :disabled="kategoriList.length === 0"
          name="sos category"
          label="name"
          v-model="kat_id"
          placeholder="Pilih Kategori SOS"
        />
        <span class="text-danger text-sm">{{ errors.first("sos category") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Sub-Kategori SOS</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="subKategoriList"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          :disabled="kat_id === null && subKategoriList.length === 0"
          name="sos sub-category"
          label="name"
          v-model="formData.sub_id"
          placeholder="Pilih Sub-Kategori SOS"
        />
        <span class="text-danger text-sm">{{ errors.first("sos sub-category") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama Syarat</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="condition name"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi dengan Syarat SOS"
        />
        <span class="text-danger text-sm">{{ errors.first("condition name") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Deskripsi</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-textarea
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="description"
          class="w-full sidebar-input"
          v-model="formData.deskripsi"
          placeholder="Isi dengan Deskripsi Syarat SOS"
        />
        <span class="text-danger text-sm">{{ errors.first("description") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
    kategoriList: [],
  },
  data() {
    return {
      kat_id: null,
      subKategoriList: [],
      formData: {
        sub_id: null,
        name: "",
        deskripsi: "",
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Syarat SOS" : "Tambah Syarat SOS";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.name !== "" &&
        this.formData.deskripsi !== "" &&
        this.formData.sub_id !== null
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    kat_id() {
      if (this.kat_id !== null) {
        this.getSubKategoriSOS();
      }
    },
    activate() {
      if (this.passData !== null) {
        this.formData.name = this.passData.name;
        this.formData.deskripsi = this.passData.deskripsi;
        this.formData.sub_id =
          this.passData.kategori !== null ? this.passData.kategori.id : null;
        this.kat_id =
          this.formData.sub_id !== null ? this.passData.kategori.kategori.id : null;
      } else {
        this.resetData();
      }
    },
  },
  methods: {
    resetData() {
      this.kat_id = null;
      this.formData.name = "";
      this.formData.deskripsi = "";
      this.formData.sub_id = null;
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    getSubKategoriSOS() {
      this.$store
        .dispatch("sos/getSubKategoriSOS", { kat_id: this.kat_id })
        .then((v) => {
          this.subKategoriList = v.data;
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      this.$store
        .dispatch("sos/cudSyaratSOS", [Object.assign(this.formData, id)])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Syarat SOS Sukses!"
                : "Tambah Syarat SOS Sukses!",
            text:
              this.passData !== null
                ? `Syarat SOS ${v.name} Berhasil diedit`
                : `Syarat SOS ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.resetData();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
};
</script>
